import Title from '@/components/InspectionReport/Items/Questions/Title.vue';
import Response from '@/components/InspectionReport/Items/Questions/Response';

const formatDate = ({ params, response, parent }) => {
    if (!response) return '';

    let dateString;
    let format;

    if (params.date && params.time) {
        dateString = `${response.replace(' ', 'T')}:00`;
        format = 'shortDateTime';
    } else if (params.date) {
        dateString = `${response}T00:00:00`;
        format = 'shortDate';
    } else if (params.time) {
        dateString = `1995-07-04T${response}:00`;
        format = 'time';
    }

    return parent.$du(new Date(Date.parse(dateString)), format);
};

export default {
    functional: true,
    props: {
        item: {
            type: Object,
            required: true,
        },
        resource: {
            type: Object,
            default: null,
        },
    },
    render(h, { props, data, parent }) {
        const { response, params } = props.item;

        return h(
            'div',
            data,
            [
                h(Title, {}, props.item.title),
                h(
                    Response, {
                        props: { responded: props.item.responded === true },
                    },
                    formatDate({ params, response, parent }),
                ),
            ],
        );
    },
};
